exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-new-credit-capacity .loans-detail-new-credit-capacity{margin-top:25px;padding-right:70px}loans-detail-new-credit-capacity .loans-detail-new-credit-capacity.mobile{padding-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailNewCreditCapacity/loansDetailNewCreditCapacity.scss
// module id = 1887
// module chunks = 0